module.exports = __webpack_public_path__ + "static/img/hezhongLogo.9e362b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hezhongLogo.png
// module id = aspM
// module chunks = 12